import DashboardSidebar from "./DashboardSidebar";
import Header from "./Header";

const DashboardLayout = ({ children }) => {
  return (
    <section>
      <Header />
      <hr className="mb-0" />
      <div className="container-fluid">
        <div className="row mx-2">
          <div
            className="col-lg-2 col-sm-2 p-0"
            style={{ background: "#475153" }}
          >
            <DashboardSidebar />
          </div>
          <div className="col-lg-10 col-sm-5">{children}</div>
        </div>
      </div>
    </section>
  );
};

export default DashboardLayout;
